/* eslint-disable import/prefer-default-export */
export const getFlyoutIsOpen = state => state.internalStore.appConfig.flyoutIsOpen;
export const getFlyoutFinishedAnimation = state =>
  state.internalStore.appConfig.flyoutAnimationIsOver;
export const getFlyoutInformations = state => state.internalStore.appConfig.flyoutInformations;
